export default "__VITE_ASSET__1a5a9029__"